import REQ_URL from '@/consts/req-url';
import { $fetch } from './fetch';
import { sProducts } from './product';

export default async function xlsLoad(file: File) {
        let formData = new FormData();
        formData.append('file', file, file.name);

        try {
            let data = await $fetch<sProducts>(REQ_URL.XLS_PRODUCTS, {
                method: 'POST',
                headers: {
                    'Content-Type': ''
                },
                body: formData
            })
            if (data.body) {
                return data
            }
            else throw new Error(data.error ? data.error : 'Что-то пошло не так, повторите позже.')
        } catch (error) {
            throw error
        }
}